<div class="modal-header">
  <h5 class="modal-title">
    <i class="bi bi-chat-dots-fill me-2"></i>
    Dein Feedback ist uns wichtig!
  </h5>
  <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <p class="text-muted mb-4">
    Hilf uns, Klausurenkiste zu verbessern. Teile uns mit, was dir gefällt oder was wir besser machen können.
  </p>

  <!-- Feedback Type Selection -->
  <div class="feedback-types mb-4">
    <label class="form-label fw-bold">Was möchtest du uns mitteilen?</label>
    <div class="row g-2">
      @for (type of feedbackTypes; track type.value) {
        <div class="col-6">
          <button 
            type="button"
            class="feedback-type-btn w-100"
            [class.active]="feedbackType === type.value"
            [style.--type-color]="type.color"
            (click)="selectType($any(type.value))">
            <i [class]="'bi ' + type.icon"></i>
            <span>{{ type.label }}</span>
          </button>
        </div>
      }
    </div>
  </div>

  <!-- Message Input -->
  <div class="mb-3">
    <label class="form-label fw-bold">
      Deine Nachricht
      @if (selectedTypeInfo) {
        <span class="badge ms-2" [style.background-color]="selectedTypeInfo.color">
          {{ selectedTypeInfo.label }}
        </span>
      }
    </label>
    <textarea 
      class="form-control" 
      rows="6"
      [(ngModel)]="message"
      [placeholder]="getPlaceholder()"
      [disabled]="isSubmitting"></textarea>
    <div class="form-text">
      <i class="bi bi-info-circle me-1"></i>
      Je detaillierter dein Feedback, desto besser können wir dir helfen.
    </div>
  </div>

  <!-- Privacy Note -->
  <div class="privacy-note">
    <i class="bi bi-shield-check me-2"></i>
    <small>Dein Feedback wird vertraulich behandelt und hilft uns, die App zu verbessern.</small>
  </div>
</div>

<div class="modal-footer">
  <button 
    type="button" 
    class="btn btn-secondary" 
    (click)="close()"
    [disabled]="isSubmitting">
    Abbrechen
  </button>
  <button 
    type="button" 
    class="btn btn-primary" 
    (click)="submitFeedback()"
    [disabled]="!message.trim() || isSubmitting">
    @if (isSubmitting) {
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
      Wird gesendet...
    } @else {
      <i class="bi bi-send-fill me-2"></i>
      Feedback senden
    }
  </button>
</div>

